var scope_0 = require('/Users/joshuamorony/Dev/projects/sites/apps/eliteionic/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e56054548ebabbda96d4961246d45f5.js').default;

var scope_1 = require('/Users/joshuamorony/Dev/projects/sites/apps/eliteionic/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/60680a9526835b6a4c7a10a3a9618d04.js').default;

var scope_2 = require('/Users/joshuamorony/Dev/projects/sites/apps/eliteionic/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2);